"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchInput = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Wrapper = _styledComponents.default.span.withConfig({
  displayName: "SearchInput__Wrapper",
  componentId: "sc-15ni3td-0"
})(["position:relative;display:inline-block;border-bottom:1px solid #000;font-size:14px;"]);

var Input = _styledComponents.default.input.withConfig({
  displayName: "SearchInput__Input",
  componentId: "sc-15ni3td-1"
})(["box-sizing:border-box;width:100%;padding:0.375em 1.75em 0.375em 0.75em;border:1px solid transparent;border-radius:0.25em;appearance:none;background:none;&:focus{outline:none;border-color:rgb(70,130,180);box-shadow:0 0 0 0.2em rgba(70,130,180,0.5);}"]);

var ClearButton = _styledComponents.default.button.attrs({
  type: 'button'
}).withConfig({
  displayName: "SearchInput__ClearButton",
  componentId: "sc-15ni3td-2"
})(["position:absolute;top:0;right:0;box-sizing:border-box;height:100%;border:none;appearance:none;background:none;cursor:pointer;outline:none;&:active,&:hover{color:rgb(40,94,142);}"]);

var SearchInput = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var id = _ref.id,
      placeholder = _ref.placeholder,
      _onChange = _ref.onChange,
      propsValue = _ref.value;

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      stateValue = _useState2[0],
      setValue = _useState2[1];

  var value = propsValue === undefined ? stateValue : propsValue;
  return /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(Input, {
    autoComplete: "off",
    id: id,
    onChange: function onChange(e) {
      setValue(e.target.value);

      _onChange(e.target.value);
    },
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Escape') {
        setValue('');

        _onChange('');
      }
    },
    placeholder: placeholder,
    ref: ref,
    type: "text",
    value: value
  }), value && /*#__PURE__*/_react.default.createElement(ClearButton, {
    "aria-label": "Clear",
    tabIndex: -1,
    onClick: function onClick() {
      setValue('');

      _onChange('');
    }
  }, "\xD7"));
});

exports.SearchInput = SearchInput;
SearchInput.propTypes = {
  id: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  onChange: _propTypes.default.func.isRequired,
  value: _propTypes.default.string
};
SearchInput.defaultProps = {
  id: undefined,
  placeholder: 'Search',
  value: undefined
};